import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Card, Form, Input, Modal, Space, Typography, message } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { apiClient } from "../../../shared/api/AllApi";

const { Title, Paragraph } = Typography;

const CONFIRM_PHRASE = "RESET_ALL_DATA";

const Maintenance = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const runReset = async () => {
    setLoading(true);
    try {
      await apiClient.post("/maintenance/reset-transactional", {
        confirm: CONFIRM_PHRASE,
        reset_purchasing: true,
      });
      message.success(t("maintenanceSuccess"));
      form.resetFields();
    } catch (e) {
      message.error(e?.response?.data?.message || t("maintenanceFailed"));
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    if (values.confirm !== CONFIRM_PHRASE) {
      message.error(t("maintenanceConfirmMismatch"));
      return;
    }
    Modal.confirm({
      title: t("maintenanceConfirmModalTitle", "Reset all finance data?"),
      content: t("maintenanceConfirmModalBody", "This will permanently delete all finance transactional data. This cannot be undone."),
      okText: t("maintenanceSubmit"),
      okButtonProps: { danger: true },
      cancelText: t("cancel", "Cancel"),
      onOk: runReset,
    });
  };

  return (
    <div className="list-page" style={{ maxWidth: 640 }}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Title level={3}>{t("maintenanceTitle")}</Title>
        <Alert
          type="error"
          showIcon
          icon={<WarningOutlined />}
          message={t("maintenanceWarningTitle")}
          description={t("maintenanceWarningBody")}
        />
        <Card>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Paragraph type="secondary">{t("maintenanceBlurb")}</Paragraph>
            <Form.Item
              name="confirm"
              label={t("maintenanceConfirmLabel", { phrase: CONFIRM_PHRASE })}
              rules={[{ required: true, message: t("maintenanceConfirmRequired") }]}
            >
              <Input autoComplete="off" placeholder={CONFIRM_PHRASE} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" danger htmlType="submit" loading={loading} block>
                {t("maintenanceSubmit")}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Space>
    </div>
  );
};

export default Maintenance;
